<div echarts [options]="options" (chartInit)="onChartInit($event)"></div>